import { storyblokEditable } from "@storyblok/react/rsc";

import { GridContainer } from "@/components/layout/GridContainer";
import { RichTextField } from "@/components/typography/RichTextField";

type HeadlineSectionStoryblok = {
  subline?: string;
  headline?: string;
  text?: string;
  _uid: string;
  component: "headline_section";
  [k: string]: any;
};

type HeadlineSectionProps = {
  blok: HeadlineSectionStoryblok;
};

const HeadlineSection = ({ blok }: HeadlineSectionProps) => (
  <section
    className="py-4 md:py-14"
    {...storyblokEditable(blok)}
  >
    <GridContainer className="lg:!px-0">
      <div className="col-span-12 lg:col-span-10 lg:col-start-2">
        <header className="mb-8">
          {blok.subline && <p className="text-subline-sm">{blok.subline}</p>}
          {blok.headline && (
            <h2 className="text-title-event max-w-4xl">
              {blok.headline}
            </h2>
          )}
        </header>

        {blok.text && <RichTextField value={blok.text} className="mb-8 max-w-2xl text-copy" />}
      </div>
    </GridContainer>
  </section>
);

export default HeadlineSection;
